<template>
  <div class="surplus-manager-dashboard space-y-4">
    <!-- Header -->
    <div class="bg-gradient-to-br from-green-500 to-green-600 rounded-xl p-6 text-white shadow-lg">
      <h2 class="text-xl font-bold mb-2">♻️ Gestion des Surplus</h2>
      <p class="text-sm opacity-90">Banque Alimentaire Occitanie</p>
    </div>

    <!-- Liste des offres -->
    <div class="space-y-3">
      <h3 class="font-bold text-gray-800 flex items-center gap-2">
        <span class="text-green-600">⚠️</span>
        NOUVELLES OFFRES ({{ surplusOffers.length }})
      </h3>

      <div
        v-for="(offer, idx) in surplusOffers"
        :key="idx"
        class="bg-white rounded-xl p-4 shadow-sm border-2 border-gray-100"
      >
        <div class="flex items-start justify-between mb-3">
          <div>
            <h4 class="font-bold text-gray-800 flex items-center gap-2">🏫 {{ offer.school }}</h4>
            <p class="text-lg font-semibold text-gray-700 mt-1">📦 {{ offer.quantity }} | {{ offer.items }}</p>
          </div>
        </div>

        <div class="flex items-center gap-4 text-sm text-gray-600 mb-3">
          <span class="flex items-center gap-1">🕐 Jusqu'à {{ offer.until }}</span>
          <span class="flex items-center gap-1">📍 {{ offer.distance }}</span>
        </div>

        <div class="flex gap-2">
          <button
            @click="reserveOffer(offer)"
            class="flex-1 bg-green-500 hover:bg-green-600 text-white rounded-lg py-2 font-semibold transition"
          >
            ✅ Réserver
          </button>
          <button @click="viewOffer(offer)" class="px-4 bg-gray-100 hover:bg-gray-200 rounded-lg transition">👁️</button>
        </div>
      </div>
    </div>

    <!-- Mes réservations -->
    <div class="bg-white rounded-xl p-4 shadow-sm">
      <h3 class="font-bold text-gray-800 mb-3">📊 MES RÉSERVATIONS</h3>
      <div class="space-y-2">
        <div class="flex justify-between items-center">
          <span class="text-gray-600">Aujourd'hui</span>
          <span class="font-bold text-green-600">2 en cours</span>
        </div>
        <div class="flex justify-between items-center">
          <span class="text-gray-600">Ce mois</span>
          <span class="font-bold text-blue-600">23kg valorisés</span>
        </div>
      </div>
    </div>

    <!-- Actions -->
    <div class="grid grid-cols-2 gap-3">
      <button
        @click="showMap"
        class="bg-blue-500 hover:bg-blue-600 text-white rounded-lg p-4 font-semibold shadow-md transition"
      >
        🗺️ Carte des offres
      </button>
      <button
        @click="showHistory"
        class="bg-purple-500 hover:bg-purple-600 text-white rounded-lg p-4 font-semibold shadow-md transition"
      >
        📋 Historique
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SurplusManagerDashboard",
  data() {
    return {
      surplusOffers: [
        {
          school: "Ecole Primaire de Lanta",
          quantity: "8kg",
          items: "Poulet rôti + légumes",
          until: "15h30",
          distance: "2.3 km",
        },
        {
          school: "École Victor Hugo",
          quantity: "5kg",
          items: "Gratin dauphinois",
          until: "16h00",
          distance: "4.1 km",
        },
        {
          school: "École Marie Curie",
          quantity: "3kg",
          items: "Riz et haricots verts",
          until: "15h00",
          distance: "1.8 km",
        },
      ],
    }
  },
  methods: {
    reserveOffer(offer) {
      alert(`Réservation de ${offer.quantity} à ${offer.school}`)
    },
    viewOffer(offer) {
      alert(`Détails : ${offer.school}`)
    },
    showMap() {
      alert("Affichage de la carte")
    },
    showHistory() {
      alert("Affichage de l'historique")
    },
  },
}
</script>

<style scoped>
.space-y-4 > * + * {
  margin-top: 1rem;
}
.space-y-3 > * + * {
  margin-top: 0.75rem;
}
.space-y-2 > * + * {
  margin-top: 0.5rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.grid {
  display: grid;
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex {
  display: flex;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-between {
  justify-content: space-between;
}
.flex-1 {
  flex: 1 1 0%;
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.from-green-500 {
  --tw-gradient-from: #22c55e;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-green-600 {
  --tw-gradient-to: #16a34a;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.shadow-sm {
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}
.shadow-md {
  box-shadow: 0 2px 4px -2px rgb(0 0 0 / 0.1);
}
.shadow-lg {
  box-shadow: 0 4px 6px -4px rgb(0 0 0 / 0.1);
}
.border-2 {
  border-width: 2px;
}
.border-gray-100 {
  border-color: #f3f4f6;
}
.bg-white {
  background-color: #ffffff;
}
.bg-green-500 {
  background-color: #22c55e;
}
.bg-green-600 {
  background-color: #16a34a;
}
.hover\:bg-green-600:hover {
  background-color: #16a34a;
}
.bg-blue-500 {
  background-color: #3b82f6;
}
.bg-blue-600 {
  background-color: #2563eb;
}
.hover\:bg-blue-600:hover {
  background-color: #2563eb;
}
.bg-purple-500 {
  background-color: #a855f7;
}
.bg-purple-600 {
  background-color: #9333ea;
}
.hover\:bg-purple-600:hover {
  background-color: #9333ea;
}
.bg-gray-100 {
  background-color: #f3f4f6;
}
.bg-gray-200 {
  background-color: #e5e7eb;
}
.hover\:bg-gray-200:hover {
  background-color: #e5e7eb;
}
.text-white {
  color: #ffffff;
}
.text-green-600 {
  color: #16a34a;
}
.text-blue-600 {
  color: #2563eb;
}
.text-gray-600 {
  color: #4b5563;
}
.text-gray-700 {
  color: #374151;
}
.text-gray-800 {
  color: #1f2937;
}
.font-bold {
  font-weight: 700;
}
.font-semibold {
  font-weight: 600;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.w-full {
  width: 100%;
}
.opacity-90 {
  opacity: 0.9;
}
.transition {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
button {
  cursor: pointer;
  border: none;
  background: none;
}
button:hover {
  opacity: 0.9;
}
</style>
